import { render, staticRenderFns } from "./CompanyInvoiceAddDialog.vue?vue&type=template&id=3b8a6a98&scoped=true"
import script from "./CompanyInvoiceAddDialog.vue?vue&type=script&lang=js"
export * from "./CompanyInvoiceAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8a6a98",
  null
  
)

export default component.exports